
interface Props {
  fill?: string;
  size?: number;
  className?: string;
}

export default function Cloud(props: Props) {
  return (
    <svg
      className={props.className}
      width={props.size}
      // height="21"
      viewBox="0 0 29 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4297 20.4375H7.70312C5.63914 20.4375 3.71789 19.7233 2.29338 18.4256C0.814492 17.0784 0 15.2102 0 13.1648C0 11.0864 0.758418 9.29436 2.19313 7.98187C3.21889 7.04267 4.58449 6.37676 6.11152 6.05745C6.25228 6.02823 6.38408 5.96585 6.49606 5.87545C6.60804 5.78506 6.69697 5.66924 6.75553 5.53756C7.29921 4.30984 8.11358 3.22192 9.13727 2.35576C10.6348 1.10178 12.4893 0.437583 14.5 0.437583C16.7618 0.427709 18.9385 1.30201 20.5685 2.87507C21.9692 4.22791 22.9191 6.01597 23.3541 8.10232C23.389 8.27341 23.4723 8.43079 23.594 8.55563C23.7158 8.68047 23.8708 8.7675 24.0405 8.8063C26.6211 9.38186 29 11.2574 29 14.5284C29 16.4256 28.3067 17.9818 26.9944 19.0301C25.8412 19.9506 24.2631 20.4375 22.4297 20.4375Z"
        fill={props.fill}
      />
    </svg>
  );
}
